<template>
  <div class="c-subject-nav">
    <ul class="c-subject-nav__list">
      <li
        v-for="item in [SUBJECT_ALL, ...SUBJECTS]"
        :key="item.value"
        :class="{
          'c-subject-nav__list__item': true,
          ['c-subject-nav__list__item--' + item.value]: true,
          'current': item.value === props.subject
        }"
      >
        <a href="#" @click.prevent="emit('click', item.value)">
          <span class="label">{{ item.name }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import { SUBJECTS, SUBJECT_ALL } from "@/consts/subject";
  const props = withDefaults(
    defineProps<{
      subject?: string
    }>(),
    {
      subject: SUBJECT_ALL.value
    }
  )
  const emit = defineEmits<{
    (e: 'click', value: string): void
  }>()

</script>

<style lang="scss" scoped>
</style>
